import { useIntl } from 'react-intl';
import { type IPageUser } from '../../../../common/interfaces';
import { AVATAR_PLACEHOLDER } from '../../common/const';
import { Avatar } from '../Tabbed/common/styles';
import { decodeHtml } from '../../../../helpers';
import { isUserAccessRestricted } from '../../../../helpers/userAccess';

export const UserAvatar = ({ user }: { user: IPageUser }) => {
  const intl = useIntl();
  const avatarSrc = user?.avatarUrl || AVATAR_PLACEHOLDER;
  const isAccessRestricted = isUserAccessRestricted(user?.userType);
  const avatarAlt = intl.formatMessage({ id: 'page.UsersAvatar', defaultMessage: "User's avatar" });
  const avatarTitle = decodeHtml(user?.name);

  const avatar = <Avatar src={avatarSrc} alt={avatarAlt} title={avatarTitle} />;

  if (isAccessRestricted || !user?.linkUrl) {
    return avatar;
  }

  return (
    <a href={user.linkUrl} title={avatarTitle}>
      {avatar}
    </a>
  );
};
